import { render, staticRenderFns } from "./Campanha.vue?vue&type=template&id=200cee48&scoped=true"
import script from "./Campanha.vue?vue&type=script&lang=js"
export * from "./Campanha.vue?vue&type=script&lang=js"
import style0 from "./Campanha.vue?vue&type=style&index=0&id=200cee48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200cee48",
  null
  
)

export default component.exports